import { useQuery } from "@tanstack/react-query";
import { applicationsApi, ApplicationSummary } from "api/applications";

export const useApplicationSummary = (
  applicationId: string | number | undefined
) =>
  useQuery<ApplicationSummary>({
    queryKey: ["APPLICATION", String(applicationId), "summary"],
    queryFn: () => applicationsApi.getApplicationSummary(String(applicationId)),
    enabled: !!applicationId
  });
